// Configuration centralisée pour toute l'application
interface Config {
  apiUrl: string;
  frontendUrl: string;
  getImageUrl: (path: string) => string;
  getProfileImageUrl: (path: string) => string;
}

export const config: Config = {
  apiUrl: process.env.NODE_ENV === 'production' 
    ? 'https://api.okolisy.com'
    : '',
  
  frontendUrl: process.env.NODE_ENV === 'production'
    ? 'https://okolisy.com'
    : 'http://localhost:8080',
  
  getImageUrl: (path: string): string => {
    if (!path) return '';
    if (path.startsWith('http')) return path;
    const cleanPath = path.replace(/^\/storage\//, '').replace(/^\/+/, '');
    if (process.env.NODE_ENV === 'production') {
      return `https://api.okolisy.com/storage/${cleanPath}`;
    }
    return `/storage/${cleanPath}`;
  },

  // ✅ Nouvelle méthode pour les photos de profil
  getProfileImageUrl: (path: string): string => {
    if (!path) return '';
    if (path.startsWith('http')) return path;
    const cleanPath = path.replace(/^\/profiles\//, '').replace(/^\/+/, '');
    if (process.env.NODE_ENV === 'production') {
      return `https://api.okolisy.com/storage/profiles/${cleanPath}`;
    }
    return `/storage/profiles/${cleanPath}`;
  }
};